import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createI18n } from 'vue-i18n';
import { parse } from 'yaml';
import es from './locales/es.yaml?raw';
import pt from './locales/pt.yaml?raw';
import 'vuetify/dist/vuetify.css';
import '@mdi/font/css/materialdesignicons.css';
import { createVuetify } from 'vuetify';
import {
  VAlert, VApp, VAppBar, VAutocomplete, VBtn, VBtnToggle, VCard, VCardActions, VCardSubtitle, VCardText, VCardTitle,
  VCarousel, VCarouselItem, VChip, VCol, VCombobox, VContainer, VDialog, VDivider, VEmptyState, VExpansionPanel,
  VExpansionPanels, VExpansionPanelText, VExpansionPanelTitle, VFileInput, VFooter, VForm, VIcon, VImg, VList,
  VCheckbox, VListItem, VListItemSubtitle, VListItemTitle, VListSubheader, VMain, VNavigationDrawer, VPagination, VProgressLinear, VRadio, VRadioGroup, VRow, VSelect,
  VSkeletonLoader, VSpacer, VSwitch, VTab, VTable, VTabs, VTextField, VTextarea, VWindow, VWindowItem, VMenu
} from 'vuetify/components';
import * as directives from 'vuetify/directives';
import App from './App.vue';
import router from './router';

const messages = { es: parse(es), 'pt-BR': parse(pt) };
const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('bralink_locale') || 'es',
  fallbackLocale: 'es',
  messages
});

const components = {
  VAlert, VApp, VAppBar, VAutocomplete, VBtn, VBtnToggle, VCard, VCardActions, VCardSubtitle, VCardText, VCardTitle,
  VCarousel, VCarouselItem, VChip, VCol, VCombobox, VContainer, VDialog, VDivider, VEmptyState, VExpansionPanel,
  VExpansionPanels, VExpansionPanelText, VExpansionPanelTitle, VFileInput, VFooter, VForm, VIcon, VImg, VList,
  VCheckbox, VListItem, VListItemSubtitle, VListItemTitle, VListSubheader, VMain, VNavigationDrawer, VPagination, VProgressLinear, VRadio, VRadioGroup, VRow, VSelect,
  VSkeletonLoader, VSpacer, VSwitch, VTab, VTable, VTabs, VTextField, VTextarea, VWindow, VWindowItem, VMenu
};

createApp(App)
  .use(createPinia())
  .use(router)
  .use(i18n)
  .use(createVuetify({
    components,
    directives,
    display: { mobileBreakpoint: 720 },
    theme: {
      defaultTheme: 'bralink',
      themes: {
        bralink: {
          dark: false,
          colors: { primary: '#0E4A78', secondary: '#E5B300', success: '#2FA84F', background: '#F3F5F7' }
        }
      }
    }
  }))
  .mount('#app');
